<template>
  <div>
    <div
      v-if="noData"
      class="nowzb-wrapper"
      :style="{
        height: Height + 'px',
        backgroundSize: '100% ' + Height + 'px'
      }"
    >
      <div class="nodata" v-if="showNo">
        <img src="../../assets/images/noShequ.png" @click="showNo = false" />
      </div>
    </div>
    <div v-else style="position: relative;">
      <Carousel
        arrow="always"
        :style="{ width: Width + 'px', height: Height + 'px' }"
        @on-change="changeInd"
        v-model="startInd"
        v-if="isReload"
      >
        <CarouselItem v-for="(item, index) in shequList" :key="index">
          <div
            :style="{
              height: Height + 'px',
              backgroundSize: '100% ' + Height + 'px'
            }"
            class="wsq-wrapper box"
          >
            <div class="box wsq-header" :style="{ top: Height * 0.018 + 'px' }">
              <div class="wsq-text">{{ item.name }}</div>
            </div>
            <wsq-left
              :height="Height"
              :width="Width"
              :info="info"
              :leftScroll="leftScroll"
            ></wsq-left>
            <wsq-mid
              :height="Height"
              class="box_f1"
              :width="Width"
              :manager="manager"
              :leader="leader"
              :yuqiNumber="yuqiNumber"
              :weibanliNumber="weibanliNumber"
              :huodongNumber="huodongNumber"
              :qiandaoNumber="qiandaoNumber"
            ></wsq-mid>
            <wsq-right
              :height="Height"
              :width="Width"
              :shequActive="shequActive"
            ></wsq-right>
          </div>
        </CarouselItem>
      </Carousel>
    </div>
  </div>
</template>

<script>
import wsqLeft from "./components/wsqLeft";
import wsqMid from "./components/wsqMiddle";
import wsqRight from "./components/wsqRight";
var that;
export default {
  inject: ["reload"],
  components: {
    wsqLeft,
    wsqMid,
    wsqRight
  },
  data() {
    return {
      Height: window.document.body.offsetHeight - 60,
      Width: window.document.body.offsetWidth,
      shequList: [], //微社区集合
      totalIndex: -1, //微社区个数 -1 ，当做index用的
      startInd: 0, //走马灯开始index
      nowIndex: 0, //当前走马灯index
      info: {
        remark: "",
        totalNumber: 0,
        zoneId: 0,
        zoneName: "",
        qrcodeUrl: ""
      }, // 微支部或微社区的基本信息
      leader: [], // 委员
      manager: {
        headPicUrl: "",
        realName: "",
        unionId: ""
      }, // 管理员
      leftScroll: [],
      yuqiNumber: 0, //逾期事件数量
      weibanliNumber: 0, //未办理事件数量
      huodongNumber: 0, //活动数量
      qiandaoNumber: 0, //签到数量
      shequActive: [],
      noData: false, //没有社区微支部数据
      showNo: true,
      isReload: true,
    };
  },
  watch: {},
  computed: {},
  mounted: function() {
    that = this;
    window.addEventListener("resize", this.handleResize);
    this.Height = window.document.body.offsetHeight - 60;
    this.Width = window.document.body.offsetWidth;
    if (this.Height < 788) {
      this.Height = 788;
    }
    if (this.$route.params.index) {
      this.startInd = this.$route.params.index;
      this.nowIndex = this.$route.params.index;
    }
    this.getSqList();
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize(event) {
      this.isReload = false;
      this.Width = window.document.body.offsetWidth;
      this.Height = document.documentElement.clientHeight - 60;
      // this.reload();
      if (this.Height < 700) {
        this.Height = 700;
      }
      if (this.Width < 1300) {
        this.Width = 1300;
      }
      this.$nextTick(() => {
        this.isReload = true;
      });
    },
    getSqList(cb) {
      that.$store.commit("updateSpinShow", true);
      var url = this.urlobj.getOrg();
      this.$get(url, {
        communityId: that.$store.state.streetorcommunityid,
        zoneType: 1 //1微社区 2微支部
      }).then(res => {
        if (res.rows.length > 0) {
          that.noData = false;
          that.shequList = res.rows.map(item => {
            return {
              name: item.zoneName,
              id: item.zoneId
            };
          });
          // 修改索引 必须是同步函数
          cb && typeof cb === "function" && cb(res);
          var id = that.shequList[that.startInd].id;
          that.promiseData(id);
        } else {
          that.$store.commit("updateSpinShow", false);
          that.noData = true;
        }
      });
    },
    promiseData(id) {
      that.$store.commit("updateSpinShow", true);
      var getSqDetail = that.getSqDetail(id);
      var getEvent = that.getEvent(id);
      Promise.all([getSqDetail, getEvent]).then(res => {
        that.$store.commit("updateSpinShow", false);
        //处理getSqDetail的数据
        let _t = res[0].rows[0];
        // 初始化info
        this.info = {
          totalNumber: _t.info.totalNumber,
          zoneName: _t.info.zoneName,
          qrcodeUrl: _t.info.qrcodeUrl
        };
        // 初始化图片
        var imgArr = [];
        _t.pic.map(item => {
          imgArr.push({ img: item.picPath });
        });
        this.leftScroll = [
          { text: _t.info.remark ? _t.info.remark : "" }
        ].concat(imgArr);
        // 初始化管理员
        this.manager = {
          headPicUrl: _t.manager.length > 0 ? _t.manager[0].headPicUrl : "",
          realName: _t.manager.length > 0 ? _t.manager[0].realName : "",
          unionId: _t.manager.length > 0 ? _t.manager[0].unionId : ""
        };
        // 初始化 委员
        this.leader = _t.leader.map(item => {
          return {
            id: item.id,
            headPicUrl: item.headPicUrl,
            proTitle: item.proTitle,
            realName: item.realName,
            unionId: item.unionId
          };
        });
        //活动 签到数量
        that.huodongNumber = _t.activityCount.activityCount;
        that.qiandaoNumber = _t.activityCount.signCount;

        //处理getEvent 的数据
        var data = res[1];
        that.yuqiNumber = data.rows[0].count.overdueNumber;
        that.weibanliNumber = data.rows[0].count.unProcessedNumber;
        that.shequActive = data.rows[0].list.map(item => {
          return {
            title: item.title,
            state: item.eventStatus,
            pic: item.coverPicUrl,
            time: that.$util.FormatDate(
              Number(item.createTime),
              "yyyy-MM-dd  HH:mm:ss"
            )
          };
        });
      });
    },
    getSqDetail(id) {
      let url = this.urlobj.zoneInfo(id);
      return this.$get(url);
    },
    getEvent(id) {
      var url = this.urlobj.getZoneEvent(id);
      return this.$get(url);
    },
    changeInd(oldValue, value) {
      this.nowIndex = value;
      that.promiseData(that.shequList[value].id);
    },
    toDetail() {
      var id = this.shequList[this.nowIndex].id;
      this.$router.push({
        name: "communityDetail",
        params: { zoneId: id, index: that.nowIndex }
      });
    }
  },
  created: function() {}
};
</script>

<style scoped>
.nowzb-wrapper {
  position: relative;
  background-image: url("../../assets/staticsPic/wsqbi.jpg");
  background-repeat: no-repeat;
}
.wsq-wrapper {
  position: relative;
  padding-top: 150px;
  background-image: url("../../assets/staticsPic/wsqbi.jpg");
  background-repeat: no-repeat;
}
.title-img {
  height: 80px;
  width: 150px;
}
.wsq-header {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  vertical-align: top;
  background-image: url("../../assets/staticsPic/fang.png");
  background-repeat: no-repeat;
  font-size: 55px;
  padding-left: 20px;
  padding-top: 20px;
  background-size: 150px 83px;
}
.wsq-text {
  font-family: "KaiTi";
  color: transparent;
  background: url("../../assets/images/wsqtext.png");
  background-repeat: repeat-x;
  -webkit-background-clip: text;
  white-space: nowrap;
  max-width: 1000px;
  overflow: hidden;
  font-weight: 600;
}
.nodata {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.margin-all {
  margin: 17.5px;
}
.margin-top {
  margin-top: 17.5px;
}
.margin-bottom {
  margin-bottom: 17.5px;
}
.margin-left {
  margin-left: 17.5px;
}
.margin-right {
  margin-right: 17.5px;
}
.box-btw {
  justify-content: space-between;
}
</style>
